import React from "react";
import config from "../../../config"; // Pages

import { SearchPage } from "./search";
export var Routes = [{
  name: "Search",
  path: config.routes.get("property.search"),
  component: SearchPage,
  exact: !0
}, {
  name: "Results",
  path: config.routes.get("property.results"),
  component: function component(a) {
    return /*#__PURE__*/React.createElement(SearchPage, Object.assign({}, a, {
      showResults: !0
    }));
  },
  exact: !0
}, {
  name: "Results",
  path: config.routes.get("landforsale.results"),
  component: function component(a) {
    return /*#__PURE__*/React.createElement(SearchPage, Object.assign({}, a, {
      showResults: !0,
      onlyLots: !0
    }));
  },
  exact: !0
}];
export * from "./search";